import { message } from 'antd';
import { RcFile } from 'antd/lib/upload';

export const checkFileFormat = (file: any) => {
  const isFormatValid = file.type === 'image/jpeg' || file.type === 'image/png';
  const isSizeValid = file.size / 1024 / 1024 < 10;

  if (!isFormatValid)
    message.error(
      'Vous ne pouvez utiliser que des images au format JPEG ou PNG.'
    );

  if (!isSizeValid) message.error("L'image envoyée doit peser moins de 15 Mo.");

  return isFormatValid && isSizeValid;
};

export const fileToDataUri = (file: RcFile) =>
  new Promise((resolve, reject) => {
    const reader = new window.FileReader();
    reader.onload = (event: ProgressEvent<FileReader>) => {
      resolve(event.target?.result);
    };
    reader.readAsDataURL(file);
  });

export const displayFilePreview = (
  file: RcFile,
  callback: (dataUri: any) => void
) => {
  if (checkFileFormat(file)) {
    fileToDataUri(file).then((dataUri: any) => callback(dataUri));
  }
  return false;
};
